import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { UserDataService } from '../../data-services/user.service';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { HasClaimDirective } from '../../security/has-claim.directive';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user.edit.html',
  styleUrls: ['./user.edit.css'],
  providers: [MessageService, DialogService],
  imports: [FormsModule, Toast, CommonModule, HasClaimDirective]
})
export class UserEditComponent implements OnInit {
  @Output() operationComplete = new EventEmitter<string>();
  constructor(private userDataService: UserDataService,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private messageService: MessageService) {
  }

  user: any = {};
  roles: any = [];
  loading: boolean;
  saveUserName: string;
  editmode: boolean = false;
  editRole: boolean = false;

  ngOnInit() {
    this.loading = true;
    this.saveUserName = this.config.data.userName;
    this.getUser(this.saveUserName);

  }

  onSubmit(form) {
    this.save();
  }

  public getUser(userName) {
    if (userName == '') {
      this.userDataService.getEmptyModel().subscribe((data: any) => {
        this.user = data;
        this.editmode = true;
        this.loading = false;
      });
    }
    else {
      this.userDataService.get(userName).subscribe((data: any) => {
        this.user = data;
        this.userDataService.getUserRoles(userName).subscribe((data: any) => {
          this.roles = data;
          this.loading = false;
        });
      });
    }
  }

  public save() {
    this.loading = true;
    this.userDataService.save(this.user).subscribe((data: any) => {
      this.getUser(this.user.UserName);
      this.messageService.add({ severity: 'success', summary: 'User Saved', detail: `Saved user [${this.user.UserName}]` });
      console.log('User Saved!');
      this.loading = false;
      this.saveComplete();
    });
  }

  saveComplete() {
    this.editmode = false;
    this.operationComplete.emit(this.user);
  }

  public toggleEdit() {
    if (this.editmode) {
      this.getUser(this.saveUserName);
    }
    this.editmode = !this.editmode;
  }

  public toggleRoleEdit() {
    if (!this.editRole) {
      this.userDataService.getAllRolesForUser(this.user.UserName).subscribe((data: any) => {
        this.roles = data;
        this.editRole = true;
      });
    } else {
      this.userDataService.getUserRoles(this.user.UserName).subscribe((data: any) => {
        this.roles = data;
        this.editRole = false;
      });
    }
  }

  public saveRoles() {
    this.userDataService.saveUserRoles(this.roles).subscribe((data: any) => {
      this.userDataService.getUserRoles(this.user.UserName).subscribe((data: any) => {
        this.roles = data;
        this.editRole = false;
      });
    });
  }

  public removeRole(i) {
    this.user.Roles.splice(i, 1);
  }
}
